import { Theme, css } from '@emotion/react';
import { listItemHoverStyles, listItemLeftDecoration } from 'omakase/ListItem/listItemCssDefs';

export const popper = (theme: Theme) => css`
  & .MuiAutocomplete-option {
    min-height: auto;
    padding: 0;
  }
  & .MuiAutocomplete-noOptions {
    display: none;
  }
  & .MuiAutocomplete-paper {
    border-radius: 0;
    box-shadow: ${theme.shadow};
  }
  & .MuiAutocomplete-option[data-focus='true'] > * > *:not(:hover) {
    ${listItemHoverStyles(theme)}
    ${listItemLeftDecoration(theme, false)}
  }
`;

export const textField = (theme: Theme) => css`
  &.MuiInputBase-root.MuiAutocomplete-inputRoot {
    padding-right: 0;
  }

  & .MuiAutocomplete-endAdornment {
    right: ${theme.spacing(1.75)}px;
  }
`;
